
<template>
  <div class=" ">
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onSubmit)" autocomplete="off">
        <!-- Học viên -->
        <div class="row">
          <div class="col-md-6 mb-3">
            <label>Học viên cần gia sư <span class="text-danger">*</span></label>
            <ValidationProvider name="Học viên" rules="required" v-slot="{ errors }">
              <el-select v-model="form.studentId" class="w-100" placeholder="Tìm tên, SĐT, mã học viên"
                         filterable remote reserve-keyword :remote-method="searchStudent"
                         :loading="loadingStudents" clearable @change="form.lessons = []">
                <el-option v-for="s in students" :key="s.id" :label="studentLabel(s)" :value="s.id"/>
              </el-select>
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </div>

          <!-- Buổi học cần gia sư -->
          <div class="col-md-6 mb-3" >
            <label>Buổi học cần gia sư <span class="text-danger">*</span></label>
            <div>
              <ValidationProvider name="Buổi hoc" rules="required" v-slot="{ errors }">
              <el-select v-model="form.lessons" multiple placeholder="Chọn buổi học" class="w-100" :disabled="form.studentId === '' " @change="handleData()">
                <el-option
                    v-for="item in lessons"
                    :key="item.lesson_id"
                    :label="item.text"
                    :value="item.lesson_id">
                </el-option>
              </el-select>
              </ValidationProvider>
            </div>
          </div>

          <!-- Buổi 1 -->
          <div v-if="form.lessons.length > 0" class="col-md-12 mb-3" v-for="(lesson, index) in dateAndTimeLessons" :key="lesson.lessonId">
            <DateTimeOfLesson :lesson="lesson" :studentId="form.studentId" />
          </div>
        </div>

        <div class="d-flex justify-content-end">
          <el-button @click="comeBack()">Quay lại</el-button>
          <el-button type="primary" class="ml-2" native-type="submit" :loading="submitting">Đặt lịch</el-button>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { GET_USER_BY_PHONE } from '@/core/services/store/user/users.module'
import {GET_LESSONS, GET_STUDENT_OF_TUTOR, POST_AFTER_OPENING} from "@/core/services/store/tutor/tutor.module";
import DateTimeOfLesson from "@/view/pages/tutor/task-management/add-task-management/component/DateTimeOfLesson.vue";

export default {
  name: 'AfterOpeningTutoring',
  components: {DateTimeOfLesson},
  props: {
    timeSlots: { type: Array, default: () => ['07:00 - 08:00','08:00 - 09:00','13:00 - 14:00','19:00 - 20:00'] }
  },
  data () {
    return {
      submitting: false,
      loadingStudents: false,
      students: [],
      form: {
        studentId: '',
        lessons: []
      },
      lessons: [],
      dateAndTimeLessons:[]
    }
  },
  methods: {
    studentLabel (s) { return `${s.name || 'Không rõ'} - ${s.phone || ''} ${s.code ? ' - ' + s.code : ''}` },
    async searchStudent (q) {
      if (!q) { this.students = []; return }
      this.loadingStudents = true
      try {
        const res = await this.$store.dispatch(GET_STUDENT_OF_TUTOR, { keyword: q })
        this.students = res?.data || []
      } finally { this.loadingStudents = false }
    },
    async onSubmit () {
        try {
          this.submitting = true
          const payload = {
            user_id: this.form.studentId,
            lessons: this.dateAndTimeLessons.map((lesson)=>({...lesson,lesson:lesson.lessonId})),
          }
          await this.$store.dispatch(POST_AFTER_OPENING,payload)
          this.$message.success('Đặt lịch gia sư thành công')
          this.closeModal(true)
        }catch (e) {
          this.$message.error(e?.data?.message || 'Có lỗi xảy ra')
        } finally {
          this.submitting = false
        }

    },
    async getLessons (){
     try {
      const res = await this.$store.dispatch(GET_LESSONS)
       this.lessons = res?.data || []
     }catch (e) {
     }
    },
    comeBack(){
      this.$emit('closeModal',false)
    },
    handleData(){
      this.dateAndTimeLessons = this.form.lessons.map(lesson => {
        return{
          lessonId: lesson,
          date:'',
          time:''
        }
      })
    },
    closeModal(isCreateSuccessful = false){
      this.$emit('closeModal',isCreateSuccessful)
    }
  },
  mounted() {
    this.getLessons()
  }
}
</script>

<style scoped>
.card{background:#fff;border-radius:8px;box-shadow:0 2px 8px rgba(0,0,0,.12)}
</style>
